import { render, staticRenderFns } from "./AdminAccountRedirection.vue?vue&type=template&id=24e7099b&scoped=true&"
import script from "./AdminAccountRedirection.vue?vue&type=script&lang=js&"
export * from "./AdminAccountRedirection.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountRedirection.vue?vue&type=style&index=0&id=24e7099b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7099b",
  null
  
)

export default component.exports